import { Component, OnInit, ViewChild } from '@angular/core'
import { MatTabsModule } from '@angular/material/tabs'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { LegalEntityClientComponent } from '../legal-entity-client/legal-entity-client.component'
import { SubClientComponent } from '../sub-client/sub-client.component'
import { ClientCreateComponent } from '../../../features/customer/client-create/client-create.component'
import { ConsultantClientComponent } from '../consultant-client/consultant-client.component'
import { SubClientCreateComponent } from '../../../features/customer/sub-client/sub-client-create/sub-client-create.component'

@Component({
  selector: 'client',
  imports: [
    MatTabsModule,
    MatButtonModule,
    LegalEntityClientComponent,
    SubClientComponent,
    ConsultantClientComponent,
  ],
  templateUrl: './client.component.html',
  styleUrl: './client.component.scss',
  standalone: true,
  providers: [AuthService],
})
export class ClientComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
  ) {}

  @ViewChild(LegalEntityClientComponent)
  legalEntityClient!: LegalEntityClientComponent

  @ViewChild(SubClientComponent)
  subClientComponent!: SubClientComponent

  screenLegalClient = 'clientes pessoa juridica'
  screenConsultant = 'consultores-clientes'
  screenSubClient = 'subcliente'
  // screen: string = 'cliente'
  // screen: string = 'cliente'

  ngOnInit() {}

  checkPermission(permission: string, type: 'legal' | 'sub' | 'consultant') {
    let response = false
    if (type == 'legal') {
      response = this.authService.checkPermission(
        permission,
        this.screenLegalClient,
      )
    } else if (type == 'sub') {
      response = this.authService.checkPermission(
        permission,
        this.screenSubClient,
        // 'consultores-clientes',
      )
    } else if (type == 'consultant') {
      response = this.authService.checkPermission(
        permission,
        this.screenConsultant,
      )
    }
    return response
  }

  newClient() {
    const dialogRef = this.dialog.open(ClientCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { modal: false },
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.legalEntityClient?.uploadList()
    })
  }

  teste() {
    this.subClientComponent?.uploadList()
  }

  newSubClient() {
    const dialogRef = this.dialog.open(SubClientCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: {},
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.subClientComponent?.uploadList()
    })
  }
}
